<header class="header" *ngIf="isLogged; else noAuth">
  <div class="container-fluid">
    <nav class="navbar navbar-expand-lg navbar-light">
      <!-- Logo y título -->
      <div class="d-flex align-items-center bg-white rounded p-2">
        <a
          href="https://www.alanser.eu/"
          class="navbar-brand d-flex align-items-center"
        >
          <img
            src="../../assets/img/ImgAlanser.png"
            alt="ALANSER"
            width="250"
            class="me-2"
          />
          <span class="brand-text fs-4 fw-bold text-success"
            >Área de Socios</span
          >
        </a>
      </div>

      <!-- Botón de menú móvil -->
      <button
        class="navbar-toggler"
        type="button"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menú -->
      <div
        class="collapse navbar-collapse"
        [ngbCollapse]="isCollapsed"
        id="navbarMenu"
      >
        <ul class="navbar-nav gap-3 ms-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a
              *ngIf="!isLogged"
              class="nav-link text-dark fw-semibold"
              routerLink="/login"
              [routerLinkActive]="['active']"
            >
              <i class="fas fa-sign-in-alt me-1"></i> Iniciar Sesión
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link text-dark fw-semibold"
              (click)="volver(); isCollapsed = true"
            >
              Volver
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link text-dark fw-semibold"
              (click)="inicio(); isCollapsed = true"
            >
              <i class="fas fa-home me-1"></i> Inicio
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link text-dark fw-semibold"
              (click)="cierraSesion(); isCollapsed = true"
              routerLink="/dashboard"
            >
              <i class="fas fa-sign-out-alt me-1"></i> Cerrar Sesión
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-dark fw-semibold" routerLink="/acercade">
              <i class="fas fa-home me-1"></i> Acerca de
            </a>
          </li>
        </ul>
        <span class="ms-3 fw-bold text-white" *ngIf="isLogged">
          {{ getNombreUsuario() }}
        </span>
      </div>
    </nav>
  </div>
</header>

<ng-template #noAuth> </ng-template>
